<template>
    <div class="group-tecnologies" id="Projects">
        <div class="group-up">
            <h1>Proyectos</h1>
        </div>
        <div class="group-down">
            <div class="group-down-boxes">
                <Carousel v-bind="carouselConfig">
                    <Slide v-for="(project, index) in projects" :key="index">
                        <ProjectBox
                            :bgImage="project.bgImage"
                            :title="project.title"
                            :text="project.text"
                        />
                    </Slide>
                    <template #addons>
                        <Navigation />
                    </template>
                </Carousel>
            </div>
        </div>
        
    </div>
</template>

<script>
    import 'vue3-carousel/carousel.css';
    import { Carousel, Slide, Navigation } from 'vue3-carousel';
    import ProjectBox from '../ProjectBox.vue';
    export default {
        name: 'FourthSection',
        components: {
            ProjectBox,
            Carousel,
            Slide,
            Navigation
        },
        data(){
            return{
                carouselConfig:{

                    height: 500,
                    itemsToShow: 3,
                    wrapAround: true,
                    snapAlign: 'center',
                    breakpoints: {
                        768: {
                            itemsToShow: 1.5
                        },
                        1024: {
                            itemsToShow: 3.5
                        }
                    }
                },
                projects:[
                        {
                            bgImage: 'https://i.gyazo.com/9ae4fb5c7b242f941d376c966e15e09b.jpg',
                            title: 'Proyecto 1',
                            text: 'Esto es de prueba'
                        },
                        {
                            bgImage: 'https://i.gyazo.com/9ae4fb5c7b242f941d376c966e15e09b.jpg',
                            title: 'Proyecto 2',
                            text: 'Esto es de prueba 2'
                        },
                        {
                            bgImage: 'https://i.gyazo.com/9ae4fb5c7b242f941d376c966e15e09b.jpg',
                            title: 'Proyecto 3',
                            text: 'Esto es de prueba 3'
                        },
                        {
                            bgImage: 'https://i.gyazo.com/9ae4fb5c7b242f941d376c966e15e09b.jpg',
                            title: 'Proyecto 4',
                            text: 'Esto es de prueba 4'
                        },
                        {
                            bgImage: 'https://i.gyazo.com/9ae4fb5c7b242f941d376c966e15e09b.jpg',
                            title: 'Proyecto 5',
                            text: 'Esto es de prueba 5'
                        }
                ]
            }
        }
    }

</script>

<style scoped>

.group-tecnologies{
    width: 100%;
}

.group-up{
    text-align: center;
}

.group-down{
    min-width: 100%;
    display:flex;
    justify-content: center; 
}

.group-down-boxes{
    width: 80dvw;
    display: block;
}

:root {
  --carousel-transition: 300ms;
  --carousel-opacity-inactive: 0.7;
  --carousel-opacity-active: 1;
  --carousel-opacity-near: 0.9;
}

.carousel__viewport {
  perspective: 2000px;
}

.carousel__track {
  transform-style: preserve-3d;
}

.carousel__slide--sliding {
  transition: opacity var(--carousel-transition),
    transform var(--carousel-transition);
}

.carousel.is-dragging .carousel__slide {
  transition: opacity var(--carousel-transition),
    transform var(--carousel-transition);
}

.carousel__slide {
  opacity: var(--carousel-opacity-inactive);
  transform: translateX(10px) rotateY(-12deg) scale(0.9);
}

.carousel__slide--prev {
  opacity: var(--carousel-opacity-near);
  transform: rotateY(-10deg) scale(0.95);
}

.carousel__slide--active {
  opacity: var(--carousel-opacity-active);
  transform: rotateY(0) scale(1);
}

.carousel__slide--next {
  opacity: var(--carousel-opacity-near);
  transform: rotateY(10deg) scale(0.95);
}

.carousel__slide--next ~ .carousel__slide {
  opacity: var(--carousel-opacity-inactive);
  transform: translateX(-10px) rotateY(12deg) scale(0.9);
}
</style>